.container {
	display: flex;
	flex-direction: column;
	height: 100%;
	max-height: 100%;
	overflow-y: hidden;
}

.main {
	flex: 1;
	display: flex;
	align-items: stretch;
	min-width: 0;
	overflow: hidden;
}

.dependencyReportContainer {
	display: flex;
	flex: 1;
	min-width: 0;
	overflow: hidden;
	padding-top: var(--jpo-common-base-spacing);
}

.legend {
	display: flex;
	width: 240px;
	flex-shrink: 0;
	margin-left: -1px;
	z-index: 1;
	position: fixed;
	right: 0;
	height: 100vh;
	margin-top: 57px;
}
